import { render, staticRenderFns } from "./ReportComandCancel.vue?vue&type=template&id=54717080&scoped=true"
import script from "./ReportComandCancel.vue?vue&type=script&lang=js"
export * from "./ReportComandCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54717080",
  null
  
)

export default component.exports